
import { z } from "zod";

export const ConversationChannelValues = ["EXTERNAL_REMI_PARTNER", "INTERNAL_TICKET_REMI", "INTERNAL_TASK_REMI", "INTERNAL_TASK_REMI_CONTRACTOR", "INTERNAL_BID_REMI", "INTERNAL_BID_REMI_CONTRACTOR", "INTERNAL_BID_REMI_PARTNER", "INTERNAL_ESCALATION_REMI", "INTERNAL_CONTRACTOR_REMI", "PHONE_REMI_HOMEOWNER", "PHONE_CONTRACTOR_HOMEOWNER", "PHONE_REMI_CONTRACTOR", "EMAIL_REMI_HOMEOWNER"] as const;
export const ConversationChannelSchema = z.enum(ConversationChannelValues);
export const ConversationChannel = ConversationChannelSchema.enum;
export type ConversationChannel = (typeof ConversationChannelValues)[number];
export const ConversationChannelDisplayNames = { "EXTERNAL_REMI_PARTNER": "Partner portal",
"INTERNAL_TICKET_REMI": "Ticket",
"INTERNAL_TASK_REMI": "Remi Task",
"INTERNAL_TASK_REMI_CONTRACTOR": "Contractor Task",
"INTERNAL_BID_REMI": "Remi",
"INTERNAL_BID_REMI_CONTRACTOR": "Contractor",
"INTERNAL_BID_REMI_PARTNER": "Partner",
"INTERNAL_ESCALATION_REMI": "Escalation",
"INTERNAL_CONTRACTOR_REMI": "Contractor notes",
"PHONE_REMI_HOMEOWNER": "Homeowner",
"PHONE_CONTRACTOR_HOMEOWNER": "Proxy",
"PHONE_REMI_CONTRACTOR": "Contractor phone",
"EMAIL_REMI_HOMEOWNER": "Homeowner email", } satisfies Record<ConversationChannel, string>;
